import classNames from "classnames";
import React, { useContext, useState, useEffect } from "react";
import { RegionSelectedContext } from "../../contexts/RegionSelectedContext";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Images from "../../assets/images/Images";
import { GlobalDataContext } from "../../contexts/GlobalDataContext";

// prettier-ignore
const yearLinks = {
    'es': [
        {year: 2022, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1121222.do', region: 'eu'},
        {year: 2021, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1116212.do', region: 'eu'},
        {year: 2020, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1112425', region: 'eu'},
        {year: 2019, link: 'https://www.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1106907',   region: 'eu'},
        {year: 2018, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1099991', region: 'eu'},
        {year: 2017, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1098145', region: 'eu'},
        {year: 2016, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1093269', region: 'eu'},

        {year: 2022, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1121216.do',    region: 'latam'},
        {year: 2021, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1116120.do',    region: 'latam'},
        {year: 2020, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1111131',    region: 'latam'},
        {year: 2019, link: 'https://www.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1107404',    region: 'latam'},
        {year: 2018, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1099990', region: 'latam'},
        {year: 2017, link: 'http://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1097986',  region: 'latam'},
        {year: 2016, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1092839', region: 'latam'},
    ],
    'en': [
        {year: 2022, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1121224.do', region: 'eu'},
        {year: 2021, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1116212.do', region: 'eu'},
        {year: 2020, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1112425', region: 'eu'},
        {year: 2019, link: 'https://www.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1106907',   region: 'eu'},
        {year: 2018, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1099997', region: 'eu'},
        {year: 2017, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1098395', region: 'eu'},
        {year: 2016, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1093369', region: 'eu'},

        {year: 2022, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1121218.do',    region: 'latam'},
        {year: 2021, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/media/group/1116218.do',    region: 'latam'},
        {year: 2020, link: 'https://documentacion.fundacionmapfre.org/documentacion/publico/es/catalogo_imagenes/grupo.do?path=1111131',    region: 'latam'},
        {year: 2019, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1099998', region: 'latam'},
        {year: 2018, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1099998', region: 'latam'},
        {year: 2017, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1098222', region: 'latam'},
        {year: 2016, link: 'https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1092965', region: 'latam'},
    ]
}

const YearSelectorContainer = styled.div`
  @media (min-width: 481px) {
    display: flex;
    align-items: center;
    font-family: DMSans-Black;
    margin-bottom: 50px;
    align-items: flex-end !important;
    min-height: 110px;

    .menuOpener {
      align-items: baseline;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      font-size: 22px;
      height: 50px;
      font-family: DMSans-Black;
    }

    .yearSelected {
      display: flex;
      margin: auto;
      font-family: DMSans-Black;
    }

    .open-arrow {
      display: flex;
      margin: auto 20px;
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: 14px solid
        ${(props: { darkMode: boolean }) =>
          props.darkMode ? "black" : "white"};
      height: 0px;
    }

    .closed-arrow {
      display: flex;
      content: "";
      margin: auto 20px;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 14px solid
        ${(props: { darkMode: boolean }) =>
          props.darkMode ? "black" : "white"};
      height: 0px;
    }

    .year {
      flex: 1 1 auto;
      display: inline-block;
      padding: 11px 20px;
      margin-right: 7px;
      cursor: pointer;
      color: #e8e5e4;
      font-size: 17px;
      background-color: #464646;
      font-family: DMSans-Black;
      transition: background-color 0.3s, color 0.3s;
    }

    .year:hover {
      background-color: #fbfbfb;
      color: #464646;
    }

    .selected {
      background-color: #fbfbfb;
      color: #464646;
    }

    .open-yearsList {
      display: flex;
      flex-direction: row;
      transition: all 0.3s ease-out, width 0.3s ease-out;
      justify-content: flex-end;
      align-items: flex-end;
      height: 50%;
    }

    .closed-yearsList {
      opacity: 0;
      overflow: hidden;
      display: none;
    }

    .yearSelectTitle {
      display: none;
    }

    .blur {
      display: none;
    }
    .yearFont {
      font-family: DMSans-Black !important;
    }

    .downloadable {
      width: 150px;
      word-break: initial;
      padding: 5px;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      font-family: DMSans-Light !important;
    }
    .mobileContainer {
      display: flex;
    }

    .separator {
      display: none;
    }

    .yearCarrat-closed {
      display: none;
    }
    .yearCarrat-open {
      display: none;
    }
  }

  @media (max-width: 480px) {
    display: flex;
    align-items: center;
    font-family: DMSans-Black;

    .menuOpener {
      cursor: pointer;
      font-size: 18px;
      display: flex;
      flex-direction: row;
      height: 50px;
    }

    .yearSelected {
      display: flex;
      margin: auto;
    }

    .open-arrow {
      display: none;
    }

    .closed-arrow {
      display: flex;
      content: "";
      margin: auto 10px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid
        ${(props: { darkMode: boolean }) =>
          props.darkMode ? "black" : "white"};
      height: 0px;
    }

    .yearSelectTitle {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .blur {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      display: block;
      opacity: 1.5;
      width: 100%;
      height: 100%;
      background-color: black;
    }

    @supports (backdrop-filter: blur(2px)) {
      .blur {
        background-color: #00000000;
        backdrop-filter: blur(2px);
      }
    }

    .open-yearsList {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;

      z-index: 999;
    }

    .closed-yearsList {
      display: none;
    }

    .year {
      display: flex;
      flex-direction: column-reverse;
      max-width: 100px;
      font-family: DMSans-Black !important;
      padding: 30px 100px;
      border-radius: 20px;
      margin-bottom: 10px;
      cursor: pointer;
      color: #e8e5e4;
      font-size: 25px;
      background-color: #464646;

      transition: all 0.3s ease-out;
    }

    .selected {
      background-color: #fbfbfb;
      color: #464646;
    }

    .downloadable {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      margin-top: 20px;
    }

    .mobileContainer {
      display: flex;
      flex-direction: row;
      transition: all 0.3s ease-out;
    }

    .separator {
      height: 2px;
      border-top: 2px solid black;
      margin-bottom: 10px;
      margin-left: -100%;
      width: 300%;
    }

    .yearWrapper {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      transition: all 0.3s ease-out;
    }

    .yearCarrat-open {
      height: 20px;
      transform: rotate(-90deg);
      margin-left: 10px;
      transition: all 0.3s ease-out;
    }

    .yearCarrat-closed {
      height: 20px;
      transform: rotate(0deg);
      margin-left: 10px;
      transition: all 0.3s ease-out;
    }

    .yearFont {
      font-family: DMSans-Black !important;
    }
  }
`;

interface YearProps {
  year: number;
  yearSelected: number;
  onClick: () => void;
}

const Year: React.FC<YearProps> = ({ year, yearSelected, onClick }) => {
  const { t, i18n } = useTranslation();
  const getCurrentLng = () =>
    i18n.language || window.localStorage.i18nextLng || "es";
  // @ts-ignore
  const { regionSelected } = useContext(RegionSelectedContext);
  const isSelectedYear = year === yearSelected;

  const lang: string = getCurrentLng();
  // @ts-ignore
  const downloadLink =
    yearLinks[lang as keyof typeof yearLinks].filter(
      (item) => item.year == year && regionSelected == item.region
    )[0] || "";
  const doDownloadLink = () => {
    window.open(downloadLink.link, "_blank");
  };

  return (
    <div
      className={classNames("year", { selected: isSelectedYear })}
      onClick={onClick}
    >
      {isSelectedYear && downloadLink.link && (
        <div className={"downloadable"} onClick={doDownloadLink}>
          <div className={"separator"} />
          <div className={"mobileContainer"}>
            <img
              src={Images.pdf_download_black}
              style={{ height: 40, marginRight: 20 }}
            />
            <div>{t("pdf.download")}</div>
          </div>
        </div>
      )}
      <div className={"yearWrapper"}>
        <div className={"yearFont"}>{year}</div>
        <img
          src={Images.expand}
          className={classNames(
            { "yearCarrat-open": isSelectedYear },
            { "yearCarrat-closed": !isSelectedYear }
          )}
        />
      </div>
    </div>
  );
};

const Years: React.FC<{
  yearSelectorOpened: boolean;
  setYearSelectorOpened: (d: boolean) => void;
  setShowRegion: (d: boolean) => void;
}> = ({ yearSelectorOpened, setYearSelectorOpened, setShowRegion }) => {
  // @ts-ignore
  const { regionSelected, yearSelected, setYearSelected } = useContext(
    RegionSelectedContext
  );
  // @ts-ignore
  const { europeRecords, latamRecords } = useContext(GlobalDataContext);

  let boolSelectedYear = false;

  const onYearClick = (year: number) => () => {
    const x = window.matchMedia("(max-width: 480px)");

    setYearSelectorOpened(false);
    setShowRegion(true);
    setYearSelected(year);

    if (x.matches) {
      if (yearSelected != year) {
        boolSelectedYear = true;
      } else {
        boolSelectedYear = false;
      }
    }
  };

  const [years, setYears] = useState<number[]>();

  useEffect(() => {
    const base =
      regionSelected === "eu"
        ? europeRecords.map((record: { year: any }) => record.year)
        : latamRecords.map((record: { year: any }) => record.year);
    // @ts-ignore
    const years = base
      // @ts-ignore
      .filter((v, i, a) => a.indexOf(v) === i)
      // @ts-ignore
      .sort((a, b) => b - a)
      .slice(0, 4);

    setYears(years);
    setYearSelected(years[0]);
  }, [regionSelected]);

  return (
    <>
      <div className={classNames(yearSelectorOpened ? "blur" : "")} />
      <div
        className={classNames(
          yearSelectorOpened ? "open-yearsList" : "closed-yearsList"
        )}
      >
        <div className={"yearSelectTitle"}>SELECCIONA AÑO</div>
        {years &&
          years.map((year) => (
            <Year
              year={year}
              yearSelected={yearSelected}
              onClick={onYearClick(year)}
              key={`year-${year}`}
            />
          ))}
      </div>
    </>
  );
};

const YearSelectorComponent: React.FC<{
  customStyle?: object;
  darkMode?: boolean;
  setShowRegion?: (a: boolean) => void;
}> = ({
  customStyle = {},
  darkMode = false,
  setShowRegion = (a = false) => {},
}) => {
  const [yearSelectorOpened, setYearSelectorOpened] = useState(false);
  // @ts-ignore
  const { yearSelected } = useContext(RegionSelectedContext);

  const onSelectorToggle = () => {
    setYearSelectorOpened(!yearSelectorOpened);
    setShowRegion(yearSelectorOpened);
  };

  return (
    <YearSelectorContainer
      className={classNames(yearSelectorOpened ? "open" : "closed")}
      style={{ ...customStyle }}
      darkMode={darkMode}
    >
      <div className="menuOpener" onClick={onSelectorToggle}>
        <div className="yearSelected">{yearSelected}</div>
        <div
          className={classNames(
            yearSelectorOpened ? "open-arrow" : "closed-arrow"
          )}
        />
      </div>
      <Years
        yearSelectorOpened={yearSelectorOpened}
        setYearSelectorOpened={setYearSelectorOpened}
        setShowRegion={setShowRegion}
      />
    </YearSelectorContainer>
  );
};

export default YearSelectorComponent;
